import React from 'react';
import './ChargesPicker.css';
import DropdownMenu from './DropdownMenu';
import { CHARGE_SCALING_KIND, chargesLabel } from '../../core/spellCharges';

/**
 * How many charges a charged line or boost holds — or how many casts a
 * cast-scaling spell has had — 1 to its cap. With a `name`, the counts are
 * tiers of that name instead ("Souffrance 1" to "Souffrance 10"); with
 * `labels`, each tier is named outright ("Direct", "À travers un portail").
 *
 * Clicks and keys stop here: it sits inside rows that are themselves buttons
 * (a spell line toggles a criterion, a boost card toggles the boost), and a
 * portal's events still bubble through the React tree to them.
 */
const ChargesPicker = ({
    value, max, lang = 'fr', disabled = false, onChange, kind = CHARGE_SCALING_KIND, name = null, labels = null,
}) => (
    <span
        className="charges-picker"
        onClick={(e) => e.stopPropagation()}
        onKeyDown={(e) => e.stopPropagation()}
        role="presentation"
    >
        <DropdownMenu
            disabled={disabled}
            activeIndex={Math.max(0, Math.min(max, value) - 1)}
            items={Array.from({ length: max }, (_, i) => ({
                label: labels?.[i] || (name ? `${name} ${i + 1}` : chargesLabel(i + 1, lang, kind)),
                onClick: () => onChange?.(i + 1),
            }))}
        />
    </span>
);

export default ChargesPicker;
